import { Request } from "./HttpService";

export const ManagementService = {
  forgetCandidateByEmail: function (email) {
    return Request(`vitae/management/forget/${email}`, "DELETE");
  }
};
